import { IMeasurementSystemId } from '@src/interfaces/profile.interfaces';
import { IUserMeasure } from '@src/interfaces/user.interfaces';

export const currentMeasurement = (
  id: IMeasurementSystemId | undefined | null,
): IUserMeasure => {
  return {
    isMetric: id === 0,
    isImperial: id === 1,
  };
};

export const splitFeetInches = (
  inchesTotal: number,
): { feet: number; inches: number } => {
  const feet = Math.floor(inchesTotal / 12);
  const inches = inchesTotal % 12;

  return { feet, inches };
};
